import React, { useState } from "react";
export const SyllabusCompliancesContext = React.createContext<any>(null);
export const SyllabusCompliancesContextProvider = (props: any) => {
  const [syllabusCompliances, setSyllabusCompliances] = useState<any>({});
  const value = {
    syllabusCompliances,
    setSyllabusCompliances,
  };
  return (
    <SyllabusCompliancesContext.Provider value={value}>
      {props.children}
    </SyllabusCompliancesContext.Provider>
  );
};
